module.exports = __webpack_public_path__ + "static/media/tipoutLogo.d37ee923.png";